import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './FormRecap.css';

import bravo from '../assets/forms/form_emojis/bravo.png';
import recap from '../assets/forms/form_emojis/recap.png';
import { ReactComponent as DropletY } from '../assets/forms/form_emojis/droplety.svg';
import { ReactComponent as HeartR } from '../assets/forms/form_emojis/heartr.svg';
import { ReactComponent as HeartbeatB } from '../assets/forms/form_emojis/heartbeatb.svg';
import { ReactComponent as Share } from '../assets/forms/form_emojis/share.svg';
import { ReactComponent as LeftArrow } from '../assets/forms/form_emojis/leftarrow.svg';

const FormRecap = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { cycleData, mentalData, sportData } = location.state || {};

  const humeur = mentalData?.mood ?? 'Non renseignée';
  const rpe = sportData?.rpe != null ? `${sportData.rpe}` : '—';
  const jourCycle = cycleData?.ovulation_test
    ? 'Ovulation'
    : cycleData?.flow
    ? `Règles (${cycleData.flow})`
    : cycleData
    ? 'Phase folliculaire'
    : 'Non renseigné';

  const hasData = !!(cycleData || mentalData || sportData);

  const handleShare = () => {
    navigate('/formulaire/share', { state: location.state });
  };

  const handleClose = () => {
    navigate('/accueil');
  };

  const handleModify = () => {
    navigate('/formulaire/cycle');
  };

  if (!hasData) {
    return (
      <div className="form-recap">
        <div className="form-recap__overlay" onClick={handleClose} />
        <div className="form-recap__modal">
          <button className="form-recap__close" onClick={handleClose} aria-label="Fermer">✕</button>
          <div className="form-recap__header">
            <h1 className="form-recap__title">Aucune donnée</h1>
            <p className="form-recap__subtitle">Veuillez remplir le formulaire pour voir le récapitulatif</p>
          </div>
          <div className="form-recap__actions">
            <button className="form-recap__close-btn" onClick={handleModify}>
              Remplir le formulaire
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="form-recap">
      <div className="form-recap__overlay" onClick={handleClose} />

      <div className="form-recap__modal">
        {/* Close button */}
        <button className="form-recap__close" onClick={handleClose} aria-label="Fermer">✕</button>

        {/* Header */}
        <div className="form-recap__header">
          <img src={bravo} alt="Bravo" className="form-recap__bravo" />
          <h1 className="form-recap__title">Bravo !</h1>
          <p className="form-recap__subtitle">Tes données de la journée sont enregistrées</p>
        </div>

        {/* Récapitulatif box */}
        <div className="form-recap__summary">
          <div className="form-recap__summary-header">
            <img src={recap} alt="Récap" className="form-recap__summary-icon" />
            <h2 className="form-recap__summary-title">Récapitulatif du jour</h2>
          </div>
          <p className="form-recap__summary-text">
            Humeur : {humeur}, RPE : {rpe}, Jour du cycle : {jourCycle}
          </p>

          {/* Cards */}
          <div className="form-recap__cards">
            <div className="form-recap__card form-recap__card--cycle">
              <DropletY className="form-recap__card-icon" />
              <span className="form-recap__card-label">Cycle</span>
              <span className="form-recap__card-value">{jourCycle}</span>
            </div>
            <div className="form-recap__card form-recap__card--humeur">
              <HeartR className="form-recap__card-icon" />
              <span className="form-recap__card-label">Humeur</span>
              <span className="form-recap__card-value">{humeur}</span>
            </div>
            <div className="form-recap__card form-recap__card--rpe">
              <HeartbeatB className="form-recap__card-icon" />
              <span className="form-recap__card-label">RPE</span>
              <span className="form-recap__card-value">{rpe !== '—' ? `${rpe}/10` : rpe}</span>
            </div>
          </div>
        </div>

        {/* Share question */}
        <p className="form-recap__share-question">
          Souhaites-tu partager ces données avec ton coach ?
        </p>

        {/* Action buttons */}
        <div className="form-recap__actions">
          <button className="form-recap__share" onClick={handleShare}>
            <Share className="form-recap__share-icon" />
            Partager à mon coach
          </button>
          <button className="form-recap__close-btn" onClick={handleClose}>
            Fermer sans partager
          </button>
        </div>

        {/* Footer with modify button */}
        <div className="form-recap__footer">
          <button className="form-recap__modify" onClick={handleModify}>
            <LeftArrow className="form-recap__modify-icon" />
            Modifier mes réponses
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormRecap;
